import { render, staticRenderFns } from "./MapiTplDetail.vue?vue&type=template&id=31d657e4&"
import script from "./MapiTplDetail.vue?vue&type=script&lang=js&"
export * from "./MapiTplDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports